import React, {useState, useEffect} from 'react';
import {createUseStyles} from 'react-jss'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import TooltipIconButton from './TooltipIconButton';

const useStyles = createUseStyles({
  root: {
    flexGrow: 1
    ,position: 'static'
    ,margin:'0 0 0 0'
    ,minWidth:'100%'
    ,"& .MuiPaper-root": {
        marginBottom: "10px !important"
      }
  },
  menuButton: {
    marginRight: '4px',
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    paddingRight: 10
    ,paddingLeft: 10
  }
  ,appBar : {
    margin: '0 0 0 0'
  }
});

function useTitle(itemsButtons, keyRef, defaultTitle, defaultIcon){

    const [title, setTitle] = useState(defaultTitle);
    const [iconTitle, setIconTitle] = useState(defaultIcon);

    useEffect(() => {
        const p = itemsButtons.filter((btn) => {return btn.keyRef === keyRef} );
        if (p.length){
            setTitle(p[0].label);
            setIconTitle(p[0].icon);
        }
    }, [itemsButtons, keyRef])
    
    return {
        title
        ,iconTitle
    }
}

export default function DenseAppBar(props) {
    const classes = useStyles();
    const [keyRef, setKeyRef] = useState(props.defaultKeyRef);
    
    const onClick = (newKeyRef, options) => {
        if (props.onIconClick(newKeyRef, options)){
            setKeyRef(newKeyRef)
        }
    }

    React.useEffect(()=>{
        setKeyRef(props.defaultKeyRef);
    }, [props.defaultKeyRef])
    
    const {title, iconTitle} = useTitle(props.itemsButtons, keyRef, props.defaultTitle, props.defaultIcon);

    const getTooltip = (title, tooltip) => tooltip ? <><div><b>{title}</b></div><div>{tooltip}</div></> : title

    const getIcon = (btn, indice) => {

        return ( 
            <TooltipIconButton 
                tooltip={getTooltip(btn.label, btn.tooltip)} 
                key={indice} 
                options={btn.options} 
                onClick={() => onClick(btn.keyRef, btn.options)} 
                icon={btn.icon}
            />
        )
    }

    return (
        <div className={classes.root} >
            <AppBar position="static" color='inherit' className={classes.appBar}>
                <Toolbar variant="dense"  className={classes.appBar}>
                    {iconTitle}
                    <Typography variant="h6" color={props.titleColor ?? "secondary"} className={classes.title}>
                        {title}
                    </Typography>
                    <div className={classes.grow} />
                    {props.itemsButtons.map((btn, indice) => {
                        return getIcon(btn, indice) 
                    })}
                </Toolbar>
            </AppBar>
        </div>
    );
}

DenseAppBar.defaultProps = {
    defaultTitle: 'Menú'
    ,defaultIcon: <DoubleArrowIcon/>
    ,defaultKeyRef: null
    ,onIconClick: (newKeyRef) => {}
    ,itemsButtons:[]
}